module.exports = __webpack_public_path__ + "img/502a90c9-1a3b-4300-b3f2-56d63d69e1b8.02f98758.jpg";